// extracted by mini-css-extract-plugin
export default {"updateBanner":"frontend-version_updateBanner__osIWC"};